export default function handleResponse (vue, data) {
  const store = vue.$store
  const socket = vue.$socket

  if (data.cmd === 'pong') {
    return
  }

  if (data.error && data.cmd !== 'reset_password' && data.cmd !== 'change_password' && data.cmd !== 'login') {
    store.dispatch('writeErrorResponse', data)
    return
  }

  if (data.cmd === 'init_infos') {
    store.dispatch('initInfos', data.data)
    store.dispatch('setAppReady')
    return
  }

  if (data.cmd === 'login') {
    store.dispatch('setCurrentRoom', '')
    store.dispatch('updateLoginResponse', data)
    return
  }

  if (data.cmd === 'get_rooms') {
    store.dispatch('updateRooms', data)
    return
  }

  if (data.cmd === 'get_room') {
    store.dispatch('updateRoom', data)
    return
  }

  if (data.cmd === 'settings') {
    store.dispatch('updateOwnSettings', data)
    return
  }
  if (data.cmd === 'supervisor_settings') {
    store.dispatch('updateAgentSettings', data)
    return
  }

  if (data.cmd === 'get_agents') {
    store.dispatch('updateAgentsList', data)
    return
  }

  if (data.cmd === 'reset_password') {
    store.dispatch('updateResetPassword', data)
    return
  }

  if (data.cmd === 'change_password') {
    store.dispatch('updateChangePassword', data)
    return
  }

  if (data.cmd === 'get_skills') {
    store.dispatch('updateSkills', data)
    return
  }

  if (data.cmd === 'get_messages') {
    store.dispatch('resetUnreadCount', data.room)
    store.dispatch('updateMessages', data)
    return
  }

  if (data.cmd === 'room_event') {
    if (data.data.kind === 'agent_msg' || data.data.kind === 'guest_msg' || data.data.kind === 'bot_msg') {
      if (data.data.room === store.getters.getCurrentRoomUuid) {
        store.dispatch('addMessage', data.data)
      } else {
        if (store.getters.getAllRooms.running.filter(room => room.uuid === data.data.room).length > 0 ||
        store.getters.getAllRooms.late.filter(room => room.uuid === data.data.room).length > 0) {
          store.dispatch('increaseUnreadCount', data.data.room)
          vue.$push.create(data.data.content)
        }
      }
    } else {
      socket.getRooms()
    }
    return
  }

  if (data.cmd === 'join_room') {
    store.dispatch('updateJoinRoomResponse', data)
    store.dispatch('setRoomForMessageRequest', data.room)
    socket.getRooms()
    socket.send(store.state.messages.request)
    return
  }

  if (data.cmd === 'close_room') {
    store.dispatch('updateCloseRoomResponse', data)
    store.dispatch('setRoomForMessageRequest', data.room)
    socket.getRooms()
    return
  }

  if (data.cmd === 'block_room') {
    store.dispatch('updateBlockRoomResponse', data)
    store.dispatch('setRoomForMessageRequest', data.room)
    socket.getRooms()
    return
  }

  if (data.cmd === 'transfer_room') {
    store.dispatch('updateTransferRoomResponse', data)
    store.dispatch('setRoomForMessageRequest', '')
    socket.getRooms()
    return
  }

  if (data.cmd === 'pause') {
    store.dispatch('updatePauseSetting', data.pause)
    return
  }

  if (data.cmd === 'get_history') {
    store.dispatch('updateHistoryResponse', data)
    return
  }

  if (data.cmd === 'get_products') {
    store.dispatch('updateGetProductsResponse', data)
    return
  }

  if (data.cmd === 'get_header_stats') {
    store.dispatch('updateHeaderStats', data)
    return
  }

  if (data.cmd === 'get_stats') {
    store.dispatch('updateGetStats', data)
    return
  }

  if (data.cmd === 'get_csv_stats') {
    store.dispatch('updateGetCsvStats', data)
    return
  }

  if (data.cmd === 'get_supervisor_stats') {
    store.dispatch('updateGetSupervisorStats', data)
    return
  }

  if (data.cmd === 'get_supervisor_csv_stats') {
    store.dispatch('updateGetSupervisorCsvStats', data)
    return
  }

  if (data.cmd === 'get_notes') {
    store.dispatch('updateGetNotes', data)
    return
  }

  if (data.cmd === 'get_zencalls') {
    store.dispatch('updateGetZencalls', data)
    return
  }

  if (data.cmd === 'launch_zencall') {
    store.dispatch('updateLaunchZencallResponse', data)
  }

  if (data.cmd === 'crm_research') {
    store.dispatch('updateCrmSearchResponse', data)
  }
}
